import { gql } from "@apollo/client";

export default gql`
  mutation createRequest(
    $time: Date
    $title: String
    $desc: String
    $docType: Int
    $total: Float
    $discount: Float
    $amount: Float
    $payments: [PaymentInput]
    $parentId: String
    $parentNo: String
    $parentType: Int
    $parentDocType: Int
    $parentTitle: String
    $attachments: String
    $terms: String
    $items: String
    $start: Date
    $end: Date
    $duration: Int
    $location: String
    $address: String
    $houseno: String
    $phone: String
    $customerId: String
    $customerName: String
    $customerNameAr: String
    $custgroupId: String
    $custgroupName: String
    $custgroupNameAr: String
    $departmentId: String
    $departmentName: String
    $departmentNameAr: String
    $divisionId: String
    $divisionName: String
    $divisionNameAr: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $resourseId: String
    $resourseName: String
    $resourseNameAr: String
    $classroomId: String
    $classroomName: String
    $classroomNameAr: String
    $vehicleId: String
    $vehicleName: String
    $vehicleNameAr: String
    $apartmentId: String
    $apartmentName: String
    $apartmentNameAr: String
    $equipmentId: String
    $equipmentName: String
    $equipmentNameAr: String
    $teacherId: String
    $teacherName: String
    $teacherNameAr: String
    $employeeIds: [String]
    $maninvno: String
    $note: String
  ) {
    createRequest(
      time: $time
      title: $title
      desc: $desc
      docType: $docType
      total: $total
      discount: $discount
      amount: $amount
      payments: $payments
      parentId: $parentId
      parentNo: $parentNo
      parentType: $parentType
      parentDocType: $parentDocType
      parentTitle: $parentTitle
      attachments: $attachments
      terms: $terms
      items: $items
      start: $start
      end: $end
      duration: $duration
      location: $location
      address: $address
      houseno: $houseno
      phone: $phone
      customerId: $customerId
      customerName: $customerName
      customerNameAr: $customerNameAr
      custgroupId: $custgroupId
      custgroupName: $custgroupName
      custgroupNameAr: $custgroupNameAr
      departmentId: $departmentId
      departmentName: $departmentName
      departmentNameAr: $departmentNameAr
      divisionId: $divisionId
      divisionName: $divisionName
      divisionNameAr: $divisionNameAr
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      resourseId: $resourseId
      resourseName: $resourseName
      resourseNameAr: $resourseNameAr
      classroomId: $classroomId
      classroomName: $classroomName
      classroomNameAr: $classroomNameAr
      vehicleId: $vehicleId
      vehicleName: $vehicleName
      vehicleNameAr: $vehicleNameAr
      apartmentId: $apartmentId
      apartmentName: $apartmentName
      apartmentNameAr: $apartmentNameAr
      equipmentId: $equipmentId
      equipmentName: $equipmentName
      equipmentNameAr: $equipmentNameAr
      teacherId: $teacherId
      teacherName: $teacherName
      teacherNameAr: $teacherNameAr
      employeeIds: $employeeIds
      maninvno: $maninvno
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
